import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    cdgDfCode: {
        name: () => '源标准字段',

        text: (map, node) => {
            const {cdgDfName, cdgDfUserCode, cdgName} = node.data

            if (! cdgDfName) {
                return ''
            }

            return [cdgName, cdgDfName, cdgDfUserCode].join('\n')
        },

        type: 'key',
    },

    dataTypeCode: {
        name: () => '数据类型',

        disabled: (map, node) => {
            const {bizNodeType, cdgDfUserCode, isCdgDf, isRefDf} = node.data

            return (
                '1' === isCdgDf ||
                '1' === isRefDf ||
                ('DF' === bizNodeType && cdgDfUserCode)
            )
        },

        required: () => true,

        text: (map, node) => {
            const {dataTypeGrpCode, dataTypeName} = node.data

            if (! dataTypeName) {
                return ''
            }

            if ('BDT' === dataTypeGrpCode) {
                return dataTypeName
            }
            else {
                return `【${dataTypeGrpCode}】${dataTypeName}`
            }
        },

        type: 'key',
    },

    defVal: {
        name: () => '默认值',

        hidden: (map, node) => {
            const {dataTypeCode} = node.data
            return /^(B?LOB|DATE(TIME)?)$/.test(dataTypeCode)
        },

        type: 'string'
    },

    dfDesc: {
        name: () => '字段说明',
        type: 'text',
    },

    dfUserCode: {
        name: () => '字段代码',
        required: () => true,
        type: 'string',
    },

    dfName: {
        name: () => '字段名称',
        required: () => true,
        type: 'string',
    },

    dfAlias: {
        name: () => '字段别名',
        type: 'string',
    },

    dfLen: {
        name: () => '字段长度',

        disabled: (map, node) => {
            const {cdgDfUserCode, dataTypeGrpCode, isCdgDf, isRefDf} = node.data

            return (
                'BDT' !== dataTypeGrpCode ||
                '1' === isCdgDf ||
                '1' === isRefDf ||
                cdgDfUserCode
            )
        },

        hidden: (map, node) => '1' !== node.data.isLen,
        //required: ({isLen}) => '1' === isLen,
        type: 'number',
    },

    dfPrecision: {
        name: () => '字段精度',

        disabled: (map, node) => {
            const {cdgDfUserCode, dataTypeGrpCode, isCdgDf, isRefDf} = node.data

            return (
                'BDT' !== dataTypeGrpCode ||
                '1' === isCdgDf ||
                '1' === isRefDf ||
                cdgDfUserCode
            )
        },

        hidden: (map, node) => '1' !== node.data.isPrecision,
        //required: ({isPrecision}) => '1' === isPrecision,
        type: 'number',
    },

    isCdgDf: {
        name: () => '引用标准字段组字段',
        type: 'boolean',
    },

    isBk: {
        name: () => '是否 BK',
        type: 'boolean',
    },

    isNull: {
        name: () => '是否可空',
        disabled: (map, node) => '1' === node.data.isPk,
        type: 'boolean',
    },

    isPk: {
        name: () => '是否 PK',
        type: 'boolean',
    },

    isTcField: {
        name: () => '是否技术字段',
        disabled: (map, node) => '1' === node.data.isPk,
        type: 'boolean',
    },
})
